import {useDispatch} from 'react-redux';

import {ICC_SSO_GUIDE_DEEPLINK_TEMPLATE} from '@/consts/icc/iccSsoDeeplinkTemplates';
import useSsoLink from '@/hooks/sso/useSsoLink';
import useForwardToUsbRequiredPage from '@/hooks/useForwardToUsbRequiredPage';
import flowAvailabilityService from '@/services/aem/flowAvailabilityService';
import deviceConnectionService from '@/services/device/deviceConnectionService';
import userBrowserService from '@/services/user/userBrowserService';
import {setPendingReturnFromWebAppConnection} from '@/state/slices/globalSlice';

const useOnConnectClick = (deviceType, deviceSerialNumber = undefined) => {
    const dispatch = useDispatch();
    const isConnectionEnabled = flowAvailabilityService.isConnectionEnabled();
    const isIosDevice = userBrowserService.isIosDevice();

    const {isUsbPageRequired, redirect: redirectToUsbPage} = useForwardToUsbRequiredPage({deviceType});
    const {redirect: redirectToWebAppGuidePage} = useSsoLink({
        ssoTemplate: ICC_SSO_GUIDE_DEEPLINK_TEMPLATE,
        ssoParams: {
            deviceType,
        },
        deviceType,
        deviceSerialNumber,
        openInBluefy: isIosDevice,
    });

    const handleOnConnectClick = () => {
        const isBluefyBrowser = userBrowserService.isBluefyBrowser();
        //if connection not enabled on the pwa redirect to webapp
        const isRedirectToWebApp = !isConnectionEnabled || (isIosDevice && !isBluefyBrowser);

        if (isUsbPageRequired) {
            redirectToUsbPage();
        } else if (isRedirectToWebApp) {
            dispatch(setPendingReturnFromWebAppConnection(true));
            redirectToWebAppGuidePage();
        } else {
            deviceConnectionService.handleConnectionFlow(deviceType);
        }
    };

    return handleOnConnectClick;
};

export default useOnConnectClick;
